import styled from 'styled-components';

export const StyledProductCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 0;

  .item-info {
    display: flex;
    gap: 12px;
  }
`;

export const PriceGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const OriginalPrice = styled.span`
  text-decoration: line-through;
  opacity: 0.6;
`;

export const ImageStyled = styled.div`
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #e1e3e6;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;
